if (!('structuredClone' in globalThis)) {
  (globalThis as any).structuredClone = <T>(val: T): T =>
    JSON.parse(JSON.stringify(val));
}
